export const MOBILE_WIDTH = 800;
export const WEEK_IN_MS = 7 * 24 * 60 * 60 * 1000;
export const DAY_IN_MS = 24 * 60 * 60 * 1000;

export const COLORS = {
  primaryButton: '#FF8C69', // '#0C9BED',
  primaryButtonText: '#fff',
  blue: '#0C9BED',
};

export const THEMES = {
  ORANGE: 'orange',
  ORANGE_FULL: 'orange-full',
  ORANGE_TRANSPARENT: 'orange-transparent',
  LIGHT: 'light',
  SMALL_GREY: 'small-grey',
  PURPLE: 'purple',
  BLACK: 'black',
  GREY: 'grey',
  RUBY: 'ruby',
};

export const POPUP_SOURCES = {
  HCP: 'hcp',
  PATIENT: 'patient',
};

export const USER_INTENT_TYPES = {
  TREATMENT: 'TREATMENT',
  RESEARCH: 'RESEARCH',
  EDUCATE: 'EDUCATE',
  OTHER: 'OTHER',
};

export const QUESTIONS = {
  TREATMENTS: 'treatments',
  BIOMARKERS: 'biomarkers',
};

export const CRM_EVENTS = {
  CALL_US: 'CALL_US',
  MISSED_CALL: 'MISSED_CALL',
  TRIED_TO_SCHEDULE_A_CALL: 'TRIED_TO_SCHEDULE_A_CALL',
};
